import GroupConfiguratorExpertContainer from "../../../../components/groups/expert/GroupConfiguratorExpertContainer";
import { useFocusedMeetingAPI, useMeetingSelector } from "../../../../hooks/meeting";
import { usePopulatedMeetingData } from "../../../../hooks/populatedData";
import { useUser } from "../../../../store/session/hooks";

import { GroupExpertContainer } from "../../../../components/groups/expert/GroupExpertContainer";

import { useExpertContext } from "../context";

import { MeetingRoomAudienceType } from "@kalyzee/kast-web-sdk/websocket";
import { openMeetingActivityRoom } from "../../../../helpers/meeting";
import "./group.css";
import { useMemo } from "react";

export const MeetingGroupExpertPage = () => {
  const meetingContainerAPI = useFocusedMeetingAPI();
  const expertCtx = useExpertContext();

  const [meetingId] = useMeetingSelector(meetingContainerAPI, (state) => state.meeting?.id);
  const [session] = useMeetingSelector(meetingContainerAPI, (state) => state.session);

  const user = useUser();

  const populatedData = usePopulatedMeetingData(meetingContainerAPI);
  const { users, rooms } = populatedData ?? {};
  const activeUsers = useMemo(() => users?.filter(u => u.active) ?? [], [users]);

  const onStopSpying = () => {
    if (!meetingId || !expertCtx?.spiedGroupId) {
      return;
    }
    openMeetingActivityRoom({
      id: meetingId,
      audience: {
        type: MeetingRoomAudienceType.RoomMember,
        values: [expertCtx.spiedGroupId],
      },
    });
  };

  const currentView = expertCtx?.currentView;

  if (!user || !activeUsers || !rooms || !session || !currentView) {
    return null; // impossible
  }

  if (
    [
      "normal",
      "groups_enlistment",
    ].includes(currentView.type)
  ) {
    return (
      <GroupConfiguratorExpertContainer 
        users={activeUsers}
        rooms={rooms}
        selfUserId={user.id}
      />
    );
  }

  if (
    [
      "group", 
      "activity_one_group", 
      "activity_one_group_spy", 
      "activity_one_leader", 
      "activity_all_leaders",
    ].includes(currentView.type)
  ) {
    return (
      <GroupExpertContainer
        meetingContainerAPI={meetingContainerAPI}
        context={expertCtx}
        view={currentView}
        stopSpying={onStopSpying}
        showSelfVideo="new_source"
      />
    );
  }

  return null; // impossible
}
